import {
  createSubmission
} from "../../clients/bettercallkyle/BckApi";

export const ADMIN_SUBMISSION_TYPES = {
  TECHNICAL_ASST: 'TECHNICAL_ASST',
  WEBSITE_ADD: 'WEBSITE_ADD',
  WEBSITE_EDIT: 'WEBSITE_EDIT',
  DIRECT_CLIENT_SERVICE: 'DIRECT_CLIENT_SERVICE',
  WEB_TOOL_ASST: 'WEB_TOOL_ASST',

  // LEGACY
  CHANGE_REQUEST: 'CHANGE_REQUEST',
  SUPPORT_REQUEST: 'SUPPORT_REQUEST',
}

export const SUBMISSION_TYPES = {
  CHANGE_REQUEST: 'CHANGE_REQUEST',
  SUPPORT_REQUEST: 'SUPPORT_REQUEST'
}

export const SUBMISSION_TYPES_HUMAN_MAP = {
  [SUBMISSION_TYPES.CHANGE_REQUEST]: 'Change Request',
  [SUBMISSION_TYPES.SUPPORT_REQUEST]: 'Support Request',

  [ADMIN_SUBMISSION_TYPES.TECHNICAL_ASST]: 'Technical Assitance',
  [ADMIN_SUBMISSION_TYPES.WEBSITE_ADD]: 'Website Addition',
  [ADMIN_SUBMISSION_TYPES.WEBSITE_EDIT]: 'Website Edit',
  [ADMIN_SUBMISSION_TYPES.DIRECT_CLIENT_SERVICE]: 'Direct Client Service',
  [ADMIN_SUBMISSION_TYPES.WEB_TOOL_ASST]: 'Web Tool Assistance'
}


export const SUBMISSION_TYPES_DESCRIPTIONS = {
  [SUBMISSION_TYPES.CHANGE_REQUEST]: 'Use this when you need us to update text, images, colors, layout, or design elements on your website.',
  [SUBMISSION_TYPES.SUPPORT_REQUEST]: 'Use this when you are experiencing a technical issue or need help troubleshooting a problem.'
}

export const postSubmission = async (type, identifiers, fields, attachments, assignedTo, dueDate, reminderDate, options) => {
  const response = await createSubmission(type, identifiers, fields, attachments, assignedTo, dueDate, reminderDate, options)
  return response;
}
